import ModelUtil from '@leverege/model-util';
const TYPE = 'recovr.detail.findAsset.FindAssetDetailModel';
function getName() {
  return 'Find Asset';
}
function create(objectType) {
  return {
    type: TYPE,
    objectType,
    style: {
      minWidth: 250,
      flexWrap: 'wrap',
      background: '#f3f5f6',
      borderRadius: 8
    }
  };
}
export default {
  create,
  TYPE,
  getName,
  ...ModelUtil.createAllValue('style/minWidth', 'StyleMinWidth'),
  ...ModelUtil.createAllValue('style/flexWrap', 'StyleFlexWrap'),
  ...ModelUtil.createAllValue('style/background', 'StyleBackground'),
  ...ModelUtil.createAllValue('style/borderRadius', 'StyleBorderRadius')
};